module.exports = __webpack_public_path__ + "img/product-preview-23.d447161.png";